import { ILocalStorage } from '@utils';

const IGETUSER = 'IGetCool-USER-Info';
const notClearList = ['mallCourseProptShowTime'];
const ACCOUNT_INFO_KEY = '_igc_userinfo_key_';

export function getUser() {
  return ILocalStorage(IGETUSER) || null;
}

export function setUser(user) {
  return ILocalStorage(IGETUSER, user);
}

export function removeUserinfo() {
  // 账号打通登陆信息
  localStorage.removeItem(ACCOUNT_INFO_KEY);
  // 老的账号登陆信息
  return localStorage.removeItem(IGETUSER);
}

export function removeUser() {

  // 老的账号登陆信息
  const whitelist = {};
  // 先取出来
  notClearList.forEach(item => {
    const r = ILocalStorage(item);
    r && (whitelist[item] = r);
  });
  const result = localStorage.clear(IGETUSER);
  // 再存进去
  notClearList.forEach(item => {
    const r = whitelist[item];
    r && (ILocalStorage(item, r));
  });
  return result;
}

// 获取storage中的账号打通登陆信息
export function getAccountInfo() {
  return ILocalStorage(ACCOUNT_INFO_KEY);
}

// igc_userinfo_key 转 IGetCool-USER-Info
export function igcUserToIGetCoolUser() {
  let userInfo = null;
  try {
    const igcUserInfo = getAccountInfo();
    if (igcUserInfo) {
      const accountInfo = JSON.parse(igcUserInfo);
      accountInfo?.userId && accountInfo?.token &&  accountInfo?.phone && (userInfo = {
        phone: accountInfo?.phone,
        uid: accountInfo?.userId,
        token: accountInfo?.token,
        jwtToken: accountInfo?.jwtToken,
      });
    }
  } catch (error) {
  }
  return userInfo;
}

// 校验两个用户信息是否一致
export function checkUserInfo(userInfo1, userInfo2) {
  return userInfo1?.uid === userInfo2?.uid;
}
